import React from "react"
import styled from "styled-components"
import * as vars from "../style/vars"
import { above, below } from "../style/functions"
import { Link, RichText, Date } from "prismic-reactjs"
import Video from "../components/video"
import Header from "../components/header.js"
import StickyEnquire from "../components/sticky-enquire";
import Masterplan from "../components/masterplan"
import LocationMap from "../components/location_map"
import { Accordion, AccordionContainer } from "../components/accordion"
import Jumbotron from "../components/jumbotron"
import TextBlock from "../components/content_block"
import Photo from '../components/photo'
import TextBlockLogos from "../components/content_block_logos"
import NewsCard from '../components/news_card'

class sellingPage extends React.Component {
   constructor(props) {
      super(props)
      this.state = {
         selectedFilter    : "all",
         mainNewsItem      : 0,
         productComingSoon : false,
         nowSellingProducts: [],
         otherProducts     : [],
         comingSoonProducts: [],
         soldOutProducts   : [],
      }
   }
   componentDidMount() {
      this.props.updateSlug(this.props.data.prismicNowSellin.uid);
      this.props.updateMeta(this.props.data.prismicNowSellin.data.meta_title.text, this.props.data.prismicNowSellin.data.meta_description);
      this.props.togglePopup(false);
      this.props.updatePageType(this.props.data.prismicNowSellin.type);
      this.props.updateProductHide(false);
      this.props.updateFooterVisible(true);
   }

   UNSAFE_componentWillMount() {
      let nowSellingProducts = []
      let otherProducts      = []
      let comingSoonProducts = []
      let soldOutProducts    = []

      this.props.data.allPrismicStandardPage.edges.forEach(
         function (element) {
            element = element.node

            if (element.tags[0] && element.tags[0] == "Product") {
               let datastring = JSON.parse(element.dataString)
               let summary = []

               if (datastring.body[0] && datastring.body[0].items[0].subheader[0]) {
                  summary[0] = datastring.body[0].items[0].subheader[0]
               }

               let image = ""
               if (datastring.body[0] && datastring.body[0].items[0].img.url) {
                  image = datastring.body[0].items[0].img.url
               }

               let url = ""
               if (datastring.parent_page) {
                  url = `/${datastring.parent_page.uid}/${element.uid}`
               } else {
                  url = `/${element.uid}`
               }

               let blog = {
                  id: 3,
                  imageUrl: image,
                  title: datastring.name[0].text,
                  summary: summary,
                  readMoreUrl: url,
                  type: element.tags[0],
                  sub: datastring.status,
                  displayOrder: datastring.display_order || 99
               }

               let status = datastring.status.toLowerCase();

               if ( status.includes('now selling') ) {
                  nowSellingProducts.push(blog)
               } else if ( status.includes('coming soon') ) {
                  comingSoonProducts.push(blog)
               } else if ( status.includes('sold out') ) {
                  soldOutProducts.push(blog)
               } else {
                  otherProducts.push(blog)
               }

               if (datastring.status.toLowerCase().includes("coming soon")) {
                  this.setState({ productComingSoon: true })
               }

            }
         }.bind(this)
      )

      this.props.data.allPrismicProduct.edges.forEach(
         function (element) {
            element = element.node

            let datastring = JSON.parse(element.dataString)
            let summary = []

            if (datastring.project_section_description[0]) {
               summary[0] = datastring.project_section_description[0]
            }

            let image = ""
            if (datastring.project_feature_image.url) {
               image = datastring.project_feature_image.url
            }

            let url = ""
            if (datastring.parent_page.uid) {
               url = `/${datastring.parent_page.uid}/${element.uid}`
            } else {
               url = `/${element.uid}`
            }

            let blog = {
               id: 3,
               imageUrl: image,
               title: datastring.name[0].text,
               summary: summary,
               readMoreUrl: url,
               type: "Product",
               sub: datastring.status,
               displayOrder: datastring.display_order || 99
            }

            if ( datastring.hide_on_now_selling_page === true ) {
               return;
            }

            let status = datastring.status.toLowerCase();

            if ( status.includes('now selling') ) {
               nowSellingProducts.push(blog)
            } else if ( status.includes('coming soon') ) {
               comingSoonProducts.push(blog)
            } else if ( status.includes('sold out') ) {
               soldOutProducts.push(blog)
            } else {
               otherProducts.push(blog)
            }

            if (datastring.status.toLowerCase().includes("coming soon")) {
               this.setState({ productComingSoon: true })
            }

         }.bind(this)
      )

      nowSellingProducts.sort((a, b) => a.displayOrder - b.displayOrder);
      comingSoonProducts.sort((a, b) => a.displayOrder - b.displayOrder);
      soldOutProducts.sort((a, b) => a.displayOrder - b.displayOrder);
      otherProducts.sort((a, b) => a.displayOrder - b.displayOrder);

      this.setState({
         nowSellingProducts: nowSellingProducts,
         comingSoonProducts: comingSoonProducts,
         soldOutProducts: soldOutProducts,
         otherProducts: otherProducts,
      })
   }

   // componentDidMount() {
   //    this.props.updateMeta(
   //       "YarraBend: Off the Plan Townhouses, Apartments & Property Melbourne",
   //       "Luxury Glenvill homes, townhouses, apartments, on the edge of Kew, just 6.5km fr" +
   //       "om Melbourne CBD. An iconic new suburb of world class living."
   //    )
   // }

   handleFilterChange = (e, filter) => {
      const { news } = this.data
      const filteredNews = news.filter(i => filter === "all" || i.type === filter)
      this.setState(prevState => ({
         ...prevState,
         selectedFilter: filter,
         news: filteredNews
      }))
   }

   handleNext = () => {
      const { news } = this.state
      this.setState(prevState => ({
         ...prevState,
         mainNewsItem:
            prevState.mainNewsItem < news.length - 1 ? prevState.mainNewsItem + 1 : 0
      }))
   }

   handlePrevious = () => {
      const { news } = this.state
      this.setState(prevState => ({
         ...prevState,
         mainNewsItem:
            prevState.mainNewsItem > 0 ? prevState.mainNewsItem - 1 : news.length - 1
      }))
   }

   loadNews = e => {
      e.preventDefault()
      const { news } = this.data
      news.push({ ...news[0], id: news.length + 1 })
      this.setState(prevState => ({
         ...prevState,
         news
      }))
   }

   render() {
      var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
      var youtube_match = this.props.data.prismicNowSellin.data.youtube_url.text.match(regExp);
      
      const data = JSON.parse(this.props.data.prismicNowSellin.dataString);
      let i = 0;
      return (
         <div>
            <Header togglePopup={this.props.togglePopup} theme="dark" menu={this.props.data.prismicMainNavigation.data} />
            <StickyEnquire theme="light" togglePopupState={this.props.popupVisible} togglePopup={this.props.togglePopup} utm={this.props.utm} updateFormDetails={(first_name,last_name,phone,email) => this.props.updateFormDetails(first_name,last_name,phone,email)}/>

            <BGDark className="bg mini dark">
               <div className="grid">
                  <div className="inner">
                     <div className="col col-xs-12 col-12 ">
                        <VideoOuterWrapper>
                           <VideoWrapper>
                              <iframe width="560" height="315" src={"https://www.youtube.com/embed/"+youtube_match[1]+"?rel=0&autohide=1&modestbranding=1&mute=1&autoplay=1&loop=1&playlist="+youtube_match[1]} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                           </VideoWrapper>
                        </VideoOuterWrapper>
                     </div>
                  </div>
               </div>
            </BGDark>

            {(this.state.nowSellingProducts.length > 0 || this.state.otherProducts.length > 0) &&
               <div>
                  <div className="grid" id="now-selling">
                     <h2>Now Selling</h2>
                  </div>

                  <NewsItems className="grid two-columns">
                     {/* Output only 'new selling' products. */}
                     {this.state.nowSellingProducts.length > 0 && this.state.nowSellingProducts.map((el, i) => {
                        return (
                           <div className="col col-xs-12 col-06 padd-r" key={i}>
                              <NewsCard
                                 key={i}
                                 media_type='Image'
                                 imageUrl={el.imageUrl}
                                 titleRight={el.title}
                                 text={RichText.render(el.summary)}
                                 actionUrl={el.readMoreUrl}
                                 showSeparator={true}
                                 sub={el.sub}
                                 btn="Discover more"
                              />
                           </div>
                        )
                     })}

                     {/* Output any other products which aren't 'sold out' or 'coming soon'. */}
                     {this.state.otherProducts.length > 0 && this.state.otherProducts.map((el, i) => {
                        return (
                           <div className="col col-xs-12 col-06 padd-r" key={i}>
                              <NewsCard
                                 key={i}
                                 media_type='Image'
                                 imageUrl={el.imageUrl}
                                 titleRight={el.title}
                                 text={RichText.render(el.summary)}
                                 actionUrl={el.readMoreUrl}
                                 showSeparator={true}
                                 sub={el.sub}
                                 btn="Discover more"
                              />
                           </div>
                        )
                        
                     })}
                  </NewsItems>
               </div>
            }

            {this.state.comingSoonProducts.length > 0 &&
               <div>
                  <div className="grid" id="coming-soon">
                     <h2>Coming Soon</h2>
                  </div>

                  <NewsItems className="grid two-columns">
                     {this.state.comingSoonProducts.map((el, i) => {
                        return (
                           <div className="col col-xs-12 col-06 padd-r" key={i}>
                              <NewsCard
                                 key={i}
                                 media_type='Image'
                                 imageUrl={el.imageUrl}
                                 titleRight={el.title}
                                 text={RichText.render(el.summary)}
                                 actionUrl={el.readMoreUrl}
                                 showSeparator={true}
                                 sub={el.sub}
                                 passProperty={el.title}
                                 btn="Register Your Interest"
                              />
                           </div>
                        )
                     })}
                  </NewsItems>
               </div>
            }

            {this.state.soldOutProducts.length > 0 &&
               <div>
                  <div className="grid" id="sold-out">
                     <h2>Sold Out</h2>
                  </div>

                  <NewsItems className="grid two-columns">
                     {this.state.soldOutProducts.map((el, i) => {
                        return (
                           <div className="col col-xs-12 col-06 padd-r" key={i}>
                              <NewsCard
                                 key={i}
                                 media_type='Image'
                                 imageUrl={el.imageUrl}
                                 titleRight={el.title}
                                 text={RichText.render(el.summary)}
                                 actionUrl={el.readMoreUrl}
                                 showSeparator={true}
                                 sub={el.sub}
                                 btn="Discover more"
                              />
                           </div>
                        )
                     })}
                  </NewsItems>
               </div>
            }

            {data.body.map(function (slice, index) {
               i++
               switch (slice.slice_type) {
                  case 'popup_map':
                     return (
                        <Masterplan key={index} />
                     )
                  case 'location_map':
                     return <LocationMap key={index} />
                  case 'accordian':
                     return (
                        <AccordionContainer key={index}>
                           <div className="grid">
                              <div className="inner" >
                                 {slice.items.map((i, idx) => {
                                    return (
                                       <Accordion
                                          title={i.title[0].text}
                                          bath={i.bathroom}
                                          bed={i.bedroom}
                                          car={i.carpark}
                                          study={i.study}
                                          name={i.title[0].text}
                                          logo={i.logo.url}
                                          image={i.image.url}
                                          dir="right"
                                          cta={{ link: i['link']['url'], text: 'Read more' }}
                                          html={RichText.render(i.html)}
                                       />
                                    )
                                 })}
                              </div>
                           </div>
                        </AccordionContainer>
                     )

                  case 'text_hero':
                     return (
                        <div
                           key={index}
                           className={`bg ${data.theme}`}
                           style={{ background: data.custom_colour }}>
                           <div className="grid">
                              <div className="inner">
                                 <Jumbotron
                                    title={slice.primary.title[0] ? slice.primary.title[0].text : ''}
                                    description={slice.primary.description[0] ? slice.primary.description[0].text : ''}
                                 />
                              </div>
                           </div>
                        </div>
                     )
                  case 'text_block':
                     return (
                        <TextBlock
                           key={index}
                           header={slice.primary.title}
                           subheader={slice.primary.sub_title}
                           text={slice.primary.text}
                           buttons={slice.items}
                        />
                     )
                  case 'photo':
                     if ( slice.items.length === 0 ) {
                        return '';
                     }

                     var fixText = false
                     var hero = false
                     if (!slice[1]) {
                        fixText = true
                     }
                     if (i === 1) {
                        hero = true
                     }

                     var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
                     var youtube_match = slice.items[0].youtube__optional_.url ? slice.items[0].youtube__optional_.url.match(regExp) : false
                     
                     var class_str = Object.keys(slice.items[0].logo).length > 0 || slice.items[0].header.length > 0 || slice.items[0].subheader.length > 0 || slice.items[0].text.length > 0 || slice.items[0].link !== null ? 'bg mini' : '';

                     return (
                        <div
                           key={index}
                           className={hero ? `${class_str} ${data.theme}` : ``}
                           style={{ color: i === 1 && data.custom_colour }}>

                           {i === 1 && data.body[0].primary.hero_overlay.url
                              ? (
                                 <HeroOverlay
                                    src={data.body[0].primary.hero_overlay.url}
                                    alt="hero overlay"
                                 />
                              ) : (
                                 ''
                              )
                           }
                           {
                              i === 1 && data.body[0].items[0].youtube__optional_.url
                                 ? (
                                    <div>
                                       <BGDark className="bg mini dark">
                                          <div className="grid">
                                             <div className="inner">
                                                <div className="col col-xs-12 col-12 ">
                                                   <VideoOuterWrapper>
                                                      <VideoWrapper>
                                                      <iframe width="560" height="315" src={"https://www.youtube.com/embed/"+youtube_match[1]+"?rel=0&autohide=1&modestbranding=1&mute=1&autoplay=1&loop=1&playlist="+youtube_match[1]} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                                      </VideoWrapper>
                                                   </VideoOuterWrapper>
                                                </div>
                                             </div>
                                          </div>
                                       </BGDark>

                                       {!!fixText &&
                                          <div className="grid" style={{marginBottom: '5rem'}}>
                                             <div className="inner" >
                                                <MainCopy className="col col-xs-12 col-06 ">
                                                         {slice.items[0].logo && (
                                                         <img src={slice.items[0].logo.url} />
                                                         ) }
                                                   {RichText.render(slice.items[0].header)}

                                                   {RichText.render(slice.items[0].subheader)}
                                                </MainCopy>
                                                <Text isHero={hero} className="col col-xs-12 col-04">
                                                   {RichText.render(slice.items[0].text)}

                                                   {/* if no link, no show. if external link, target blank. if linked to booking, show special format. else show Enquire Now */}
                                                   {!slice.items[0].link ? '' : slice.items[0].link.includes('http') ?
                                                      <a className="btn btn-arrow" href={`${slice.items[0].link}`} target="_blank" ><span>Read More</span> </a>
                                                      :
                                                      slice.items[0].link.includes('booking') ?
                                                      <Link className="btn btn-square" to={slice.items[0].link}>
                                                         <span>
                                                            Book an appointment
                                                            </span>
                                                      </Link>
                                                      : slice.items[0].link && <Link className="btn btn-square white" to={slice.items[0].link}>
                                                      <span>
                                                         Enquire Now
                                                         </span> </Link>
                                                   }
                                                </Text>
                                             </div>
                                          </div>
                                       }
                                    </div>
                                 )
                                 : (
                                    <Photo
                                       slides={slice.items}
                                       fixText={fixText}
                                       hero={hero}
                                       key={i}
                                       theme={data.theme}
                                    />
                                 )
                           }

                        </div>
                     )
                  case 'text':
                     return (
                        <div className="grid" key={index}>
                           <div className="inner" style={{ marginBottom: '-5rem' }}>{RichText.render(slice.primary.text)}</div></div>
                     )

                  case 'content_block___logos':
                     return (

                        <TextBlockLogos
                           key={index}
                           logos={slice.items}
                           header={slice.primary.title[0].text}
                           subheader={slice.primary.sub_heading[0].text}
                        />

                        // <div className="grid ">
                        //    <div className="inner">
                        //       <div className="col col-xs-12 col-06 ">
                        //          <div>
                        //             <h2>{slice.primary.title[0].text}</h2>
                        //          </div>
                        //          <div>
                        //             <p>{slice.primary.sub_heading[0].text}</p>
                        //          </div>
                        //       </div>
                        //       <div className="col col-xs-12 col-04">
                        //          <div className="logo-grid">
                        //          {
                        //             slice.items.map((i, idx) => (
                        //                <div className='logo-grid__item'>
                        //                   <div className='logo-grid__content'>
                        //                      {i.logo.url}
                        //                   </div>
                        //                </div>
                        //             ))
                        //          }
                        //          </div>
                        //       </div>
                        //    </div>
                        // </div>
                     )

                  case 'content_block':
                     var dir = null
                     if (!slice.items[1]) {
                        dir = i % 2 ? 'left' : 'right'
                     }

                     slice.items.forEach((item, index) => {
                        if ( item.media_type === 'Carousel' ) {
                           var carousel_images = [];

                           if ( Object.keys(item.image).length > 0 ) {
                              carousel_images.push({
                                 img: item.image,
                              });
                           }

                           if ( Object.keys(item.image_2).length > 0 ) {
                              carousel_images.push({
                                 img: item.image_2,
                              });
                           }

                           if ( Object.keys(item.image_3).length > 0 ) {
                              carousel_images.push({
                                 img: item.image_3,
                              });
                           }

                           if ( Object.keys(item.image_4).length > 0 ) {
                              carousel_images.push({
                                 img: item.image_4,
                              });
                           }

                           slice.items[index].carousel_images = carousel_images;
                        }
                     });
                     
                     return (
                        <NewsItems className={dir ? `grid ` : ' grid two-columns'} key={index}>
                           {slice.items.map((i, idx) => (
                              <div
                                 className={dir ? `` : 'col col-xs-12 col-06 padd-r'}
                                 key={idx}>
                                 <NewsCard
                                    key={idx}
                                    tile_id={i.tile_id && i.tile_id.length > 0 ? i.tile_id[0].text.replace(/[^A-Za-z0-9-_]/g, '').toLowerCase() : ''}
                                    imageUrl={i.image.url}
                                    titleLeft=""
                                    passProperty={i.title[0] ? i.title[0].text : ''}
                                    titleRight={i.title[0] ? i.title[0].text : ''}
                                    text={RichText.render(i.text)}
                                    sub={
                                       i['sub_heading'][0]
                                          ? i['sub_heading'][0]['text']
                                          : ' '
                                    }
                                    showSeparator
                                    actionUrl={i['link']}
                                    imageDirection={dir}
                                    layout={dir ? `horizontal` : 'vertical'}
                                    className={dir ? ` two-columns` : ' '}
                                    btn={i.btn}
                                    media_type={i.media_type || 'Image'}
                                    videoUrl={i.media_type === 'YouTube' && i.youtube_url.length > 0 ? i.youtube_url[0].text : false}
                                    carousel_images={i.media_type === 'Carousel' && i.carousel_images.length > 0 ? i.carousel_images : []}
                                 />
                              </div>
                           ))}
                        </NewsItems>
                     )
               }
            })}
         </div>
      )
   }
}

const NewsFilter = styled.div`
   display: flex;
   border-bottom: 0.2rem solid ${vars.colors.body};
   margin-bottom: ${vars.padding.inner * 3}rem;
   & > div {
      display: inline-flex;
      margin-left: auto;
      margin-right: auto;
      & > p {
         margin-right: 5rem;
      }
      & > p:not(:first-child) {
         color: ${vars.colors.inactiveColor};
         cursor: pointer;
      }
      & > p:last-child {
         margin-right: 0;
      }
      & > p.active {
         color: ${vars.colors.body};
      }
   }
   ${below.mobile`
		display: none;
	`};
`

const HeroOverlay = styled.img`
   position: absolute;
   height: 70vh;
   min-height: 35rem;
   transform: translateX(-50%);
   left: 50%;
   top: 0;
   object-fit: cover;
   z-index: 1;
`

const BGDark = styled.div`
   &:after {
      display:none;
   }
   margin-bottom: 5.25rem;
`

const MainCopy = styled.div`
   padding-bottom: ${vars.padding.inner}rem;
   padding-right: ${vars.padding.inner}rem;
   border-right: ${props => props.isHero ? '1' : '1'}px solid ${vars.colors.body};
   padding-left: 5rem;
	img{
		width: 200px;
	}
   ${below.tablet`
      padding-bottom: 0;
      border-right: none;
      padding-left: 0;
   `};
`

const Text = styled.div`
   padding-left: ${vars.padding.inner}rem;

   ${below.tablet`
      border-left: none;
      padding-left: 0;
   `};

   h4 {
      padding-bottom: 3rem;
   }
   h5 {
      font-size: ${vars.padding.inner / 2}rem;
      padding-bottom: ${vars.padding.inner / 5}rem;

   }
`

const NewsItems = styled.div`
   &.two-columns > .col:nth-child(2n + 1) {
      clear: left;
   }
   &.three-columns > .col:nth-child(3n + 1) {
      clear: left;
   }
`
const VideoOuterWrapper = styled.div`

   padding: 8rem 5rem 0;
   ${below.tablet`
   padding: 8rem 3rem;
   `}
   ${below.mobile`
   padding: 8rem 1rem 4rem;
   `};

`
const VideoWrapper = styled.div`

   position: relative;
   padding-bottom: 56.25%; /* 16:9 */
   height: 0;


   iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding-bottom: 0;
      min-height: 0;
   }
`

export default sellingPage

export const pageQuery = graphql`
   query seelingPage($id: String) {
      prismicNowSellin(id: { eq: $id }) {
         id
         uid
         type
         dataString
         data {
            meta_title {
               html
               text
            }
            meta_description
            youtube_url {
               text
             }
         }
      }
      allPrismicStandardPage {
         edges {
            node {
               id
               uid
               type
               dataString
               tags
            }
         }
      }
      allPrismicProduct {
         edges {
            node {
               id
               uid
               type
               dataString
            }
         }
      }
      prismicMainNavigation {
         id
         dataString
         data {
           display_name {
             html
             text
           }
           nav {
             slice_type
             primary {
               label {
                 text
               }
               link {
                 text
               }
             }
             items {
               sub_nav_link_label {
                 text
               }
               sub_nav_link {
                 text
               }
             }
           }
         }
       }
   }
`



// WEBPACK FOOTER //
// ./src/templates/selling.js